<ng-template #content>
  <div class="lna-modal-header">
    <h4 class="modal-title">{{ titleKey | translate }}</h4>
    <button class="btn-close" (click)="onCancel()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <p>{{ descriptionKey | translate }}</p>
    <div class="structural-unit-list">
      @for (unit of units; track unit.id) {
        <label class="structural-unit-option">
          <input
            type="radio"
            name="structuralUnit"
            [value]="unit.id"
            [checked]="selectedUnitId === unit.id"
            (change)="selectedUnitId = unit.id" />
          <span>{{ unit.name }}</span>
        </label>
      }
    </div>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="!selectedUnitId" (click)="onConfirm()">
      {{ 'components.structuralUnitModal.confirm' | translate }}
    </button>
    <button class="secondary" (click)="onCancel()">
      {{ 'components.structuralUnitModal.cancel' | translate }}
    </button>
  </div>
</ng-template>
